import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SYSTEM_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const INIT_APP = '_INIT_APP';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_MENU_STATE = 'SET_MENU_STATE';
export const SHOW_CONFIRM = '_SHOW_CONFIRM';
export const HIDE_CONFIRM = '_HIDE_CONFIRM';
export const START_LOAD_APP = '_START_LOAD_APP';
export const END_LOAD_APP = '_END_LOAD_APP';
export const UPDATE_PERIOD = '_UPDATE_PERIOD';
export const LOAD_STATUS = '_LOAD_STATUS';
export const LOAD_CADES_STORE = '_LOAD_CADES_STORE';
export const INIT_CADES_STORE = '_INIT_CADES_STORE';
export const SIGN_DOCUMENT = '_SIGN_DOCUMENT';
export const SIGN_PDF = '_SIGN_PDF';
export const SIGN_DOCX = '_SIGN_DOCX';
export const SHOW_SIGN_POPUP = '_SHOW_SIGN_POPUP';
export const HIDE_SIGN_POPUP = '_HIDE_SIGN_POPUP';
export const ADD_PROGRESS_LOG = '_ADD_PROGRESS_LOG';
export const SET_LOG_LIST = '_SET_LOG_LIST';
export const SET_PROGRESS_LIST = '_SET_PROGRESS_LIST';
export const SET_PERCENT = '_SET_PERCENT';
export const SHOW_PROGRESS_BAR = '_SHOW_PROGRESS_BAR';
export const CLOSE_PROGRESS_BAR = '_CLOSE_PROGRESS_BAR';
export const STOP_PROGRESS_BAR = '_STOP_PROGRESS_BAR';
export const LOAD_FILE = '_LOAD_FILE';
export const UPLOAD_FILE = '_UPLOAD_FILE';
export const DELETE_FILE = '_DELETE_FILE';
export const UPLOAD_SIGN_FILE = '_UPLOAD_SIGN_FILE';
export const UPLOAD_UNSIGNED_FILE = '_UPLOAD_UNSIGNED_FILE';
export const LOAD_FILE_BY_URL = '_LOAD_FILE_BY_URL';
export const CREATE_EXPORT_TASK = '_CREATE_EXPORT_TASK';
export const DOWNLOAD_EXPORT_RESULT = '_DOWNLOAD_EXPORT_RESULT';
export const GET_EXPORT_TASK_STATUS = '_GET_EXPORT_TASK_STATUS';
export const GET_EXPORT_AVAILABLE_COLUMNS = '_GET_EXPORT_AVAILABLE_COLUMNS';
export const NORMALIZE_ADDRESS = '_NORMALIZE_ADDRESS';

export const initApp = createDeferredAction(SYSTEM_MODULE + INIT_APP);

export const setLocale = createDeferredAction(SYSTEM_MODULE + SET_LOCALE, formValues => (formValues));
export const setMenuState = createDeferredAction(SYSTEM_MODULE + SET_MENU_STATE);
export const showGlobalConfirm = createDeferredAction(SYSTEM_MODULE + SHOW_CONFIRM);
export const hideGlobalConfirm = createAction(SYSTEM_MODULE + HIDE_CONFIRM);

export const startLoadApp = createDeferredAction(SYSTEM_MODULE + START_LOAD_APP);
export const endLoadApp = createAction(SYSTEM_MODULE + END_LOAD_APP);
export const setUpdatePeriod = createAction(SYSTEM_MODULE + UPDATE_PERIOD);

export const loadStatus = createDeferredAction(SYSTEM_MODULE + LOAD_STATUS);
export const loadStatusSuccessful = createAction(SYSTEM_MODULE + LOAD_STATUS + SUCCESSFUL);
export const loadStatusFailed = createAction(SYSTEM_MODULE + LOAD_STATUS + FAILED);

export const loadCadesStore = createDeferredAction(LOAD_CADES_STORE);
export const loadCadesStoreSuccessful = createAction(LOAD_CADES_STORE + SUCCESSFUL);
export const loadCadesStoreFailed = createAction(LOAD_CADES_STORE + FAILED);

export const loadFile = createDeferredAction(SYSTEM_MODULE + LOAD_FILE);
export const loadFileSuccessful = createAction(SYSTEM_MODULE + LOAD_FILE + SUCCESSFUL);
export const loadFileFailed = createAction(SYSTEM_MODULE + LOAD_FILE + FAILED);

export const loadFileByUrl = createDeferredAction(SYSTEM_MODULE + LOAD_FILE_BY_URL);
export const loadFileByUrlSuccessful = createAction(SYSTEM_MODULE + LOAD_FILE_BY_URL + SUCCESSFUL);
export const loadFileByUrlFailed = createAction(SYSTEM_MODULE + LOAD_FILE_BY_URL + FAILED);

export const initCadesStore = createDeferredAction(INIT_CADES_STORE);

export const signDocument = createDeferredAction(SYSTEM_MODULE + SIGN_DOCUMENT);
export const signDocumentSuccessful = createAction(SYSTEM_MODULE + SIGN_DOCUMENT + SUCCESSFUL);
export const signDocumentFailed = createAction(SYSTEM_MODULE + SIGN_DOCUMENT + FAILED);

export const signPDF = createDeferredAction(SYSTEM_MODULE + SIGN_PDF);
export const signPDFSuccessful = createAction(SYSTEM_MODULE + SIGN_PDF + SUCCESSFUL);
export const signPDFFailed = createAction(SYSTEM_MODULE + SIGN_PDF + FAILED);

export const signDocx = createDeferredAction(SYSTEM_MODULE + SIGN_DOCX);
export const signDocxSuccessful = createAction(SYSTEM_MODULE + SIGN_DOCX + SUCCESSFUL);
export const signDocxFailed = createAction(SYSTEM_MODULE + SIGN_DOCX + FAILED);

export const showSignPopup = createDeferredAction(SYSTEM_MODULE + SHOW_SIGN_POPUP);
export const hideSignPopup = createAction(SYSTEM_MODULE + HIDE_SIGN_POPUP);

export const addProgressLog = createAction(SYSTEM_MODULE + ADD_PROGRESS_LOG);
export const setProgressList = createAction(SYSTEM_MODULE + SET_PROGRESS_LIST);
export const stoppedProgressBar = createAction(SYSTEM_MODULE + STOP_PROGRESS_BAR);
export const closeProgressBar = createAction(SYSTEM_MODULE + CLOSE_PROGRESS_BAR);
export const showProgressBar = createAction(SYSTEM_MODULE + SHOW_PROGRESS_BAR);
export const setLogList = createAction(SYSTEM_MODULE + SET_LOG_LIST);
export const setPercent = createAction(SYSTEM_MODULE + SET_PERCENT);

export const uploadFile = createDeferredAction(SYSTEM_MODULE + UPLOAD_FILE);
export const uploadFileSuccessful = createAction(SYSTEM_MODULE + UPLOAD_FILE + SUCCESSFUL);
export const uploadFileFailed = createAction(SYSTEM_MODULE + UPLOAD_FILE + FAILED);

export const deleteFile = createDeferredAction(SYSTEM_MODULE + DELETE_FILE);
export const deleteFileSuccessful = createAction(SYSTEM_MODULE + DELETE_FILE + SUCCESSFUL);
export const deleteFileFailed = createAction(SYSTEM_MODULE + DELETE_FILE + FAILED);

export const uploadSignFile = createDeferredAction(SYSTEM_MODULE + UPLOAD_SIGN_FILE);
export const uploadSignFileSuccessful = createAction(SYSTEM_MODULE + UPLOAD_SIGN_FILE + SUCCESSFUL);
export const uploadSignFileFailed = createAction(SYSTEM_MODULE + UPLOAD_SIGN_FILE + FAILED);

export const uploadUnsignedFile = createDeferredAction(SYSTEM_MODULE + UPLOAD_UNSIGNED_FILE);
export const uploadUnsignedFileSuccessful = createAction(SYSTEM_MODULE + UPLOAD_UNSIGNED_FILE + SUCCESSFUL);
export const uploadUnsignedFileFailed = createAction(SYSTEM_MODULE + UPLOAD_UNSIGNED_FILE + FAILED);

export const createExportTask = createDeferredAction(SYSTEM_MODULE + CREATE_EXPORT_TASK);
export const createExportTaskSuccessful = createAction(SYSTEM_MODULE + CREATE_EXPORT_TASK + SUCCESSFUL);
export const createExportTaskFailed = createAction(SYSTEM_MODULE + CREATE_EXPORT_TASK + FAILED);

export const downloadExportResult = createDeferredAction(SYSTEM_MODULE + DOWNLOAD_EXPORT_RESULT);
export const downloadExportResultSuccessful = createAction(SYSTEM_MODULE + DOWNLOAD_EXPORT_RESULT + SUCCESSFUL);
export const downloadExportResultFailed = createAction(SYSTEM_MODULE + DOWNLOAD_EXPORT_RESULT + FAILED);

export const getExportTaskStatus = createDeferredAction(SYSTEM_MODULE + GET_EXPORT_TASK_STATUS);
export const getExportTaskStatusSuccessful = createAction(SYSTEM_MODULE + GET_EXPORT_TASK_STATUS + SUCCESSFUL);
export const getExportTaskStatusFailed = createAction(SYSTEM_MODULE + GET_EXPORT_TASK_STATUS + FAILED);

export const getExportAvailableColumns = createDeferredAction(SYSTEM_MODULE + GET_EXPORT_AVAILABLE_COLUMNS);
export const getExportAvailableColumnsSuccessful = createAction(SYSTEM_MODULE + GET_EXPORT_AVAILABLE_COLUMNS + SUCCESSFUL);
export const getExportAvailableColumnsFailed = createAction(SYSTEM_MODULE + GET_EXPORT_AVAILABLE_COLUMNS + FAILED);

export const normalizeAddress = createDeferredAction(SYSTEM_MODULE + NORMALIZE_ADDRESS);
export const normalizeAddressSuccessful = createAction(SYSTEM_MODULE + NORMALIZE_ADDRESS + SUCCESSFUL);
export const normalizeAddressFailed = createAction(SYSTEM_MODULE + NORMALIZE_ADDRESS + FAILED);
